'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _keyPaths = require('../constants/keyPaths');

var _CrmCreationSource = require('./CrmCreationSource');

var _CrmCreationSource2 = _interopRequireDefault(_CrmCreationSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TicketUpdateMetadata = function (_Record) {
  _inherits(TicketUpdateMetadata, _Record);

  function TicketUpdateMetadata() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TicketUpdateMetadata);

    return _possibleConstructorReturn(this, (TicketUpdateMetadata.__proto__ || Object.getPrototypeOf(TicketUpdateMetadata)).call(this, _extends({}, properties, {
      crmCreationSource: properties.crmCreationSource ? (0, _CrmCreationSource2.default)(properties.crmCreationSource) : null
    })));
  }

  return TicketUpdateMetadata;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _keyPaths.UPDATE_TYPE, null), _defineProperty(_Record2, 'pipelineId', null), _defineProperty(_Record2, 'pipelineName', null), _defineProperty(_Record2, 'pipelineStageId', null), _defineProperty(_Record2, 'pipelineStage', null), _defineProperty(_Record2, 'crmCreationSource', null), _Record2), 'TicketUpdateMeta'));

exports.default = TicketUpdateMetadata;
module.exports = exports['default'];